import React, { useEffect, useState, useReducer } from "react"
import AddNewRefProvider from "./AddNewRefProvider"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import Pagination from "../../../shared/Pagination/Pagination"
import { useSelector } from "react-redux"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import usePagination from "../../../../customhooks/usePagination"

const RefProvider = (props) => {
    const { type, Settings } = { ...props };
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Ref-Provider')?.IsDeleted
    const API_URL = enumUtil.controller.General
    const [isOpenRefProvider, setIsOpenRefProvider] = useState(false)
    const [RefProviderData, setRefProviderData] = useState([]);
    const [RefProviderID, setRefProviderID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(Settings?.DefaultPageView === "Card View" ? true : false);
    const [totalCounts, setTotalCounts] = useState(false)
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: true
    }

    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const [copiedText, setCopiedText] = useState({});
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    ///////////

    const LoadData = (param, types) => {
        setIsLoading(true);
        // setRefProviderData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param;
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.RefProvider,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setRefProviderData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenRefProvider(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setRefProviderData([])
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (RefProviderData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenRefProvider(true)
                }
            }
        })
    }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam)
        }
    }
    const [npiModal, setNpiModal] = useState(false)
    const onCloseProocedNpi = () => {
        setNpiModal(false)
    }
    const proceedHeader = () => {
        return <p className="heading">Proceed with NPI Registry</p>;
    };
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])
    // open provider 
    const AddRefProvider = (ID) => {
        setIsOpenRefProvider(true)
        setNpiModal(true)
        setRefProviderID(ID)
    }

    const CloseProvider = () => {
        setIsOpenRefProvider(false)
    }
    const DeleteProvider = () => {
        setIsOpenRefProvider(false)
        setIsClose((Math.random()));
    }
    const handleLProviderDelete = (ProviderID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/DeleteSingleRecord", 'post', {
            "ID": ProviderID,
            "TableName": enumUtil.enumAPITableName.RefProvider
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Deleted Successfully!', enumUtil.enumtoaster.success)
            setIsClose((Math.random()));
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [
        {
            key: 'Name',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Name'} sortIcon={true} type={'string'} colKey={'Name'} data={RefProviderData} setData={setRefProviderData} />),
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddRefProvider(row.RefProviderID)}>{row.Name} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopyText(row.Name)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'NPI',
            name: 'NPI',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'NPI'} sortIcon={true} type={'number'} colKey={'NPI'} data={RefProviderData} setData={setRefProviderData} />),
            width: 120,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.NPI}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RefProviderID, row.NPI)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.RefProviderID}-${row.NPI}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'SSN',
            name: 'SSN',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'SSN'} sortIcon={true} type={'number'} colKey={'SSN'} data={RefProviderData} setData={setRefProviderData} />),
            width: 120,
        },
        {
            key: 'TaxonomyCode',
            name: 'Taxonomy Code',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Taxonomy Code'} sortIcon={true} type={'number'} colKey={'TaxonomyCode'} data={RefProviderData} setData={setRefProviderData} />),
            width: 150,
        },
        {
            key: 'PhoneNumber',
            name: 'Phone Number',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Phone Number'} sortIcon={true} type={'number'} colKey={'PhoneNumber'} data={RefProviderData} setData={setRefProviderData} />),
            width: 150,
        },
        {
            key: 'Address',
            name: 'Address',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Address'} sortIcon={true} type={'string'} colKey={'Address'} data={RefProviderData} setData={setRefProviderData} />),
            flex: 1,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Address}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopyText(row.Address)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                        </div>
                    </>
                );
            }
        },
    ]
    let PopupScreen = "";
    if (isOpenRefProvider) {
        PopupScreen = <AddNewRefProvider isOpenRefProvider={isOpenRefProvider} onClose={CloseProvider} onDeleteProvider={DeleteProvider} RefProviderID={RefProviderID} npiModal={npiModal} proceedHeader={proceedHeader} onCloseProocedNpi={onCloseProocedNpi} type={type} />
    }
    const CardView = () => {
        setShow(true)
        // setPerPage(-1)
    };
    const TableView = () => {
        setShow(false)
        // setPerPage(10)
    };
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
      const handleClearSearch = () => {
        setSearchParam('')
    }
    const RefProviderBody = () => {
        return (
            <>
                <div className={'container-fluid action-row br-bottom-1 br-clr'}>
                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by name or id…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter} value={searchParam} />
                                    <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                        <i className="bi bi-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddRefProvider}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                searchButton={searchButton}
                                Key={614}
                                Name={'Ref. Provider'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {show ?
                    <>
                        <Card
                            AddNew={AddRefProvider}
                            Data={RefProviderData}
                            API_URL={API_URL}
                            TableName={enumUtil.enumAPITableName.RefProvider}
                            handleDelete={DeleteProvider}
                            ID={RefProviderID}
                            dropDown={DropDowns.RefProvider}
                            isLoading={isLoading}
                            Key={614}
                            Name={'Ref. Provider'}
                            IsDeleteAllowed={IsDeleteAllowed}
                        />
                        {paginationSection}
                        {/* <Pagination
                            PerPage={PerPage}
                            PageNo={PageNo}
                            TotalPages={TotalPages}
                            handlePageClick={handlePageClick}
                            PreviousPage={PreviousPage}
                            handleFingByCreteria={handleFingByCreteria}
                            NextPage={NextPage}
                        /> */}
                    </>
                    : (
                        <div className="table-view SetupTable location_grid">
                            <Table
                                columns={columns}
                                rows={RefProviderData}
                                height='500px'
                                rowClass={rowClass}
                                // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                dynamicClass='fill-grid DataGrid-Table hk-exp-table'
                                rowHeight={25}
                                PerPage={PerPage}
                                PageNo={PageNo}
                                TotalPages={TotalPages}
                                handlePageClick={handlePageClick}
                                PreviousPage={PreviousPage}
                                handleFingByCreteria={handleFingByCreteria}
                                NextPage={NextPage}
                                Key={614}
                                Name={'Ref. Provider'}
                                isLoading={isLoading}
                                TableName={'RefProvider'}
                                handleSelectData={handleSelectData}
                                LoadData={() => LoadData(searchParam)}
                                ClearSearch={handleClearSearch}
                            />
                        </div>
                    )
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(RefProviderData?.length == 0 && isNull(searchParamType)){
    //             setIsOpenRefProvider(true)
    //         }       
    //     }
    // },[RefProviderData, searchParamType])
    return (
        <React.Fragment>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {RefProviderData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenRefProvider ? <>{PopupScreen}</> : <>{RefProviderBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {RefProviderBody()}
                </>
            }

        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(RefProvider);